import { createPanelController } from '../shared/ui-panel-base.js';
import { getProfiles, getFoods, setFoods } from '../state-manager.js';
import { loadClientFoods, updateClientFoods } from '../requests/foods.js';
import { closePanel } from '../shared/ui-panel-controller.js';

let localFoods = []; // Local working copy of foods

export const editFoodPanel = createPanelController('settings-food-edit', {
  onOpen: () => {
    console.log('[FoodEditPanel] Opening food edit panel');
    localFoods = structuredClone(getFoods());

    renderFoodList();
  },
  onClose: () => {
    document.getElementById('settings-food-edit-list').innerHTML = '';
    console.log('[FoodEditPanel] Closing food edit panel');
  },
});

function renderFoodList() {
  const ul = document.getElementById('settings-food-edit-list');
  const profiles = getProfiles();
  ul.innerHTML = '';

  localFoods.forEach(food => {
    const li = document.createElement('li');
    li.className = 'list-item';
    li.innerHTML = `
      <input name="fname" type="text" class="name-input" value="${food.name}" />
      <input name="fweight" type="number" class="weight-input" value="${food.weight}" />
      <select class="profile-select" multiple>
        ${profiles.map(profile => `
          <option value="${profile.id}" ${food.profile_ids.includes(profile.id) ? 'selected' : ''}>
            ${profile.name}
          </option>
        `).join('')}
      </select>
      <button class="lock-toggle">${food.active ? '✅' : '❎'}</button>
    `;

    const nameInput = li.querySelector('.name-input');
    nameInput.addEventListener('input', () => {
      food.name = nameInput.value;
    });

    const weightInput = li.querySelector('.weight-input');
    weightInput.addEventListener('input', () => {
      food.weight = parseInt(weightInput.value);
    });

    // const barInput = li.querySelector('.bar-input');
    // barInput.addEventListener('input', () => {
    //   food.barcode = barInput.value;
    // });

    const profileSelect = li.querySelector('.profile-select');
    profileSelect.addEventListener('change', () => {
      food.profile_ids = Array.from(profileSelect.selectedOptions).map(opt => opt.value);
    });

    const lockToggle = li.querySelector('.lock-toggle');
    lockToggle.addEventListener('click', () => {
      food.active = !food.active;
      lockToggle.textContent = food.active ? '✅' : '❎';
    });

    li.dataset.foodId = food.id;
    ul.appendChild(li);
  });
}

document.getElementById('settings-update-foods-btn')?.addEventListener('click', async () => {

  localFoods = localFoods.map(f => ({
    id: f.id,
    name: f.name,
    weight: f.weight,
    barcode: f.barcode.trim(),
    active: f.active ? 1 : 0,
    profile_ids: f.profile_ids,
    created_at: f.created_at || '',
  }));
  
  try {
    await updateClientFoods(localFoods);
    const refreshed = await loadClientFoods();
    setFoods(refreshed);
    editFoodPanel.close();
  } catch (err) {
    console.error('[EditFoods] Error updating:', err);
    alert('An error occurred during update.');
  }
});

document.querySelector('#settings-food-edit-sheet .back-btn')?.addEventListener('click', () => {
  console.log('[FoodEditPanel] Back to settings from food edit panel');
  closePanel('settings-food-edit'); // Will automatically restore previous panel (e.g. settings)
});
